/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevTerminalIcon24Solid = forwardRef('DevTerminalIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V7Zm4.043 1.293a1 1 0 0 1 1.414 0l2.54 2.54a1.65 1.65 0 0 1 0 2.334l-2.54 2.54a1 1 0 0 1-1.414-1.414L8.336 12 6.043 9.707a1 1 0 0 1 0-1.414ZM13 14a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2h-5Z" })));
});
